import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[kbButtonsMenuLabel]',
    standalone: false
})
export class ButtonsMenuLabelDirective {
  
  // -----------------------------------------------------------------------------------------------------
  // @ CONSTRUCTOR
  // -----------------------------------------------------------------------------------------------------

  constructor(public template: TemplateRef<any>) { }
}
